import { OBRAS_SOCIALES } from "@/lib/clinic";
import { Eye } from "lucide-react";

export default function ObrasSociales() {
  const loop = [...OBRAS_SOCIALES, ...OBRAS_SOCIALES];

  return (
    <section
      id="obras-sociales"
      data-testid="obras-sociales-section"
      className="py-20 md:py-24 bg-white border-y border-navy-900/5"
    >
      <div className="section-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <span className="text-[11px] tracking-[0.24em] uppercase text-turquoise-700 font-semibold">
              Obras Sociales
            </span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl tracking-tight font-medium text-navy-900 max-w-2xl">
              Atendemos a las principales obras sociales y prepagas del país.
            </h2>
          </div>
          <p className="text-sm text-navy-700/70 max-w-sm">
            Consultanos por tu cobertura. Si tu obra social no figura, escribinos por WhatsApp y te orientamos.
          </p>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="flex animate-marquee gap-14 whitespace-nowrap py-4" data-testid="obras-sociales-marquee">
          {loop.map((name, i) => (
            <div
              key={`${name}-${i}`}
              className="flex items-center gap-3 text-navy-800/70"
            >
              <Eye className="w-4 h-4 text-turquoise-500" strokeWidth={1.8} />
              <span className="font-display text-xl sm:text-2xl font-medium tracking-tight">
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
